export default __webpack_public_path__ + "static/media/PurpleW.22c71f07.png";